export const APA_STRUCTURE_TYPE_REQUEST = 'APA_STRUCTURE_TYPE_REQUEST';
export const APA_STRUCTURE_TYPE_SUCCESS = 'APA_STRUCTURE_TYPE_SUCCESS';
export const APA_STRUCTURE_TYPE_FAIL = 'APA_STRUCTURE_TYPE_FAIL';

